import { get } from '..'
import { StudentInfo } from '@/models/Reselect/StudentInfo'

export async function fetchStudentInfo() {
  const { data } = await get(`StudentInfo/self`)
  return data as StudentInfo
}
